import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppMsgType, IQuestion } from 'cat-shared/utils'
import { AppContextMenu, Pointing } from 'client/ui-building-blocks'
import { getAccountStatus, isAccountFull, displaySnackBar } from 'client/services'
import { useAppContext, useModalDialogContext } from 'client/hooks'
import { copyToClipboard } from 'client/helpers'

type Props = {
  question?: IQuestion
  isDisabled: boolean
  pointing?: Pointing
}

export const QuestionContextMenu = ({
  question = null,
  isDisabled,
  pointing = 'top left',
}: Props) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const { toggleReportQuestionModal, toggleDeleteQuestionModal } = useModalDialogContext()

  const { authUser } = useAppContext()
  const accountStatus = getAccountStatus(authUser)

  const onCopyLinkBtnClick = () => {
    const href = window.location.origin + '/question?_id=' + question._id
    copyToClipboard(href)
    displaySnackBar({
      type: AppMsgType.Info,
      text: t('question.contextMenu.msgs.linkCopied'),
    })
  }

  const onOpenBtnClick = () => {
    const href = window.location.origin + '/question?_id=' + question._id
    window.open(href)
  }

  let isDeletable = false
  let isReportable = false

  if (authUser && question) {
    if (isAccountFull(accountStatus)) {
      isDeletable = authUser._id === question.creatorId && pathname === '/browse'
      isReportable = authUser._id !== question.creatorId
    }
  }

  const MENU_ITEMS = [
    {
      label: t('question.contextMenu.items.copyLink'),
      onClick: onCopyLinkBtnClick,
    },
    {
      label: t('question.contextMenu.items.openInNewTab'),
      onClick: onOpenBtnClick,
    },
    {
      label: t('question.contextMenu.items.report'),
      onClick: () => {
        if (isReportable) {
          toggleReportQuestionModal(true)
        }
      },
      hide: !isReportable,
    },
    {
      label: t('question.contextMenu.items.delete'),
      onClick: () => {
        if (isDeletable) {
          toggleDeleteQuestionModal(true)
        }
      },
      hide: !isDeletable,
    },
  ]

  return <AppContextMenu items={MENU_ITEMS} isDisabled={isDisabled} pointing={pointing} />
}
